import { useNetwork } from '@nftx/react';
import { useQuery } from '@tanstack/react-query';
import { Address, fetchActivity } from 'nftx.js';
import { QueryKey } from '../../queryKeys';

const useVaultActivity = ({
  vaultId,
  vaultIds,
}: {
  vaultId?: string;
  vaultIds?: string[];
}) => {
  const network = useNetwork();
  const enabled = !!vaultId || !!vaultIds?.length;

  return useQuery(
    [QueryKey.POOL_ACTIVITY, network, vaultId || vaultIds?.join(',')],
    () => {
      return fetchActivity({ network, vaultId, vaultIds });
    },
    { enabled }
  );
};

export default useVaultActivity;
